import { Modal, ModalBody, ModalFooter, ModalTitle, Select, Text } from '@serodigital/ui-components';
import { SeroProps } from '@serodigital/ui-components/dist/types/SeroProps';
import * as React from 'react';

export type FirmwarUpgradeModalProps = {
  toggle: () => void;
  isOpen: boolean;
  firmwareVersions: string[];
  upgradeFirmware: (selectedFirmwareVersion: string) => void;
} & SeroProps;

export function FirmwareUpgradeModal({ toggle, isOpen, firmwareVersions, upgradeFirmware }: FirmwarUpgradeModalProps) {
  const [selectedFirmwareVersion, setSelectedFirmwareVersion] = React.useState<string>();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        toggle();
      }}
      data-qa="firmware-upgrade"
    >
      <ModalTitle data-qa="firmware-upgrade-modal-title">BEE Firmware Update</ModalTitle>
      <ModalBody>
        <Text data-qa="firmware-upgrade-modal-description">Please select firmware version from the list below</Text>
        <div className="pt-24 w-697">
          <Select
            data-qa="firmware-select"
            id="firmware-select"
            options={firmwareVersions?.map(version => ({ label: version, value: version })) || []}
            defaultValue=""
            onChange={e => setSelectedFirmwareVersion(e.target.value)}
          />
        </div>
      </ModalBody>
      <ModalFooter
        onCancel={toggle}
        onConfirm={() => upgradeFirmware(selectedFirmwareVersion)}
        confirmButtonProps={{ disabled: !selectedFirmwareVersion }}
        confirmLabel="Update"
      />
    </Modal>
  );
}
